import axiosInstance from "./AxiosInstance";

export function getActionTypeSerach(data) {
  return axiosInstance.post(`/action-type-search-list`, data);
}

export function getContactTypeSerach(data) {
  return axiosInstance.post(`/contact-type-search-list`, data);
}

export function createTask(data) {
  return axiosInstance.post(`/tasks/create`, data);
}

export function updateTask(data) {
  return axiosInstance.post(`/tasks/update`, data);
}

export function getTasksList(data) {
  return axiosInstance.post(`/tasks/list`, data);
}

export function getSearchTaskVehicleList(data) {
  return axiosInstance.post(`/tasks/vehicle-list`, data);
}

export function getSearchTaskPartsList(data) {
  return axiosInstance.post(`/tasks/part-list`, data);
}

export function getTasksDetails(data) {
  return axiosInstance.post(`/tasks/details`, data);
}

export function deleteTasksUser(data) {
  return axiosInstance.post(`/tasks/delete-user`, data);
}

export function deleteMainTasks(data) {
  return axiosInstance.post(`/tasks/delete`, data);
}

export function updateWorkingStatus(data) {
  return axiosInstance.post(`/tasks/update-working-status`, data);
}

export function createTaskChat(data) {
  return axiosInstance.post(`/tasks/chat-create`, data);
}

export function getTaskChatList(data) {
  return axiosInstance.post(`/tasks/chat-list`, data);
}

export function taskConvertToReservation(data) {
  return axiosInstance.post(`/tasks/convert-reservation`, data);
}

export function taskConvertToSales(data) {
  return axiosInstance.post(`/tasks/convert-sales`, data);
}

export function taskReportPdf(data) {
  return axiosInstance.post(`/tasks/report-pdf`, data);
}

export function updateTaskStatus(data) {
  return axiosInstance.post(`/tasks/update-tasks-status`, data);
}

export function getSendCustomerMessage(data) {
  return axiosInstance.post(`/tasks/send-customer-message`, data);
}

